// extracted by mini-css-extract-plugin
export var body = "footer-module--body--XV7bd";
export var footer = "footer-module--footer--byVaF";
export var footerIcons = "footer-module--footer-icons--1PEcN";
export var footerSeal = "footer-module--footer-seal--DGO0L";
export var iconHeart = "footer-module--icon-heart--y+F16";
export var legal = "footer-module--legal--wAC8V";
export var linkColumn = "footer-module--link-column--3tDMo";